<h1 mat-dialog-title>
    Anexos dos Pneus
</h1>

<button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step>
        <ng-template matStepLabel>Anexos</ng-template>
        <app-anexos #anexos></app-anexos>
    </mat-step>
</mat-horizontal-stepper>

<div mat-dialog-actions align="end">
    <button type="button" mat-flat-button (click)="stepper.previous()" *ngIf="stepper.selectedIndex !== 0">
        Anterior
    </button>

    <button type="button" mat-flat-button [disabled]="!stepper.selected?.stepControl?.valid" (click)="stepper.next()"
        *ngIf="stepper.selectedIndex < stepper.steps.length -1">
        Próximo
    </button>

    <button type="submit" mat-flat-button [disabled]="!anexos.files" (click)="onSubmit(anexos.files)"
        *ngIf="stepper.selectedIndex === stepper.steps.length -1">
        Salvar anexos
    </button>
</div>